import { Component, OnInit } from '@angular/core';
import { NgForm, FormGroup, FormControl, Validators, ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';
import { VendorSetupDomestic } from './../../../../models/VendorSetupDomestic';
import { VendorService } from './../../../../services/vendor.service';
import { DataService } from './../../../../services/data.service';
import { AccountService } from './../../../../services/account.service';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss']
})
export class CompanyComponent implements OnInit {
  vendorCompany:VendorSetupDomestic = new VendorSetupDomestic();
  public successMsg: string;
  errorMsg: string;
  showFailConfirmation: boolean;
  showSuccessConfirmation: boolean;
  userInfo:any;
  alive = true;
  constructor( private dataSvc: DataService,
    private vendorSvc: VendorService,
    private accountSvc: AccountService,
    private spinner: NgxSpinnerService,
    private router: Router) { }

  ngOnInit() {
  }

  onSubmit(frmVendorCompany:NgForm) {
    frmVendorCompany.value.gPVID = this.userInfo.GPVID.trim();
    console.log("Submit  activated", frmVendorCompany);

    this.vendorSvc. updateVendorCompanyInfo(frmVendorCompany)
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          
        },
        err => {
          this.errorMsg = err;
          this.showFailConfirmation = true;
        },
        () => console.log('Request Complete')
      );
  }
  
  goToMyVendor(event) {
    this.router.navigate(['/pages/vendor/myvendor/home']);
  }

  close(event) {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }

  public ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-settings-v/company/company.component.ts